var React = require('react');

function AvatarInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 25.2631C0 19.3891 4.76179 14.6274 10.6357 14.6274C16.5097 14.6274 21.2715 19.3891 21.2715 25.2631V25.6725H0V25.2631Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M16.3179 5.97035C16.3179 9.26768 13.7087 11.9407 10.4901 11.9407C7.27145 11.9407 4.66225 9.26768 4.66225 5.97035C4.66225 2.67302 7.27145 0 10.4901 0C13.7087 0 16.3179 2.67302 16.3179 5.97035Z","fill":"currentColor","key":1})]);
}

AvatarInline.defaultProps = {"width":"22","height":"26","viewBox":"0 0 22 26","fill":"none"};

module.exports = AvatarInline;

AvatarInline.default = AvatarInline;
